<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Relatório</span>
        <h3 class="page-title d-inline">Tags</h3>
        <d-button class="btn btn-success text-white float-right" @click="openFilter">Novo filtro</d-button>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col md="3">
        <label>Filtro
          <small class="ml-3 cursor-pointer" v-if="filter.id" @click="editFilter"><i class="fas fa-edit"></i>Editar</small>
        </label>
        <d-select v-model="filter">
          <option :value="option" v-for="(option, index) in filters" :key="index">{{option.name}}</option>
        </d-select>
      </d-col>
      <d-col md="1">
        <label>Mostrar:</label>
        <d-select v-model="pagination.take" :options="showTake"></d-select>
      </d-col>
      <d-col cols="auto">
        <label>Data inicial:</label>
        <datepicker :model.sync="pagination.date_from"/>
      </d-col>
      <d-col cols="auto">
        <label>Data final:</label>
        <datepicker :model.sync="pagination.date_to"/>
      </d-col>
      <d-col cols="auto">
        <div class="d-block w-100 p-3"></div>
        <d-button @click="setFilter" :disabled="this.filter.id === null">Filtrar</d-button>
      </d-col>
      <d-col cols="auto">
        <div class="d-block w-100 p-3"></div>
        <d-button theme="secondary" @click="openExportCsv" :disabled="this.filter.id === null">Exportar csv</d-button>
        <d-button theme="success" class=" ml-3" @click="exportPdf" :disabled="this.filter.id === null">Exportar docx</d-button>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="12" class="d-flex mt-3">
        <span>Tags:</span>
        <d-badge class="ml-2" theme="primary" v-for="(tag, index) in tags" :key="index">{{ index }} : {{ tag }}</d-badge>
      </d-col>
      <d-col cols="12">
        <tag-list-items></tag-list-items>
      </d-col>
    </d-row>
    <d-row v-if="posts.total_items">
      <d-col cols="12" class="my-3">
        <pagination :total-items="posts.total_items" :pagination.sync="pagination"></pagination>
      </d-col>
    </d-row>
    <tag-filter-modal :title="filterTitle"/>
    <report-posts-modal />
  </d-container>
</template>
<script>
import { mapActions } from 'vuex';
import { catchPdf, downloadWordFile } from '_utils';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import Pagination from '_shared/Pagination.vue';
import ReportService from '_services/rest/modules/report';
import TagListItems from '../components/TagListItems.vue';
import TagFilterModal from '../components/modal/TagFilterModal.vue';
import ReportPostsModal from '../components/modal/ReportPostsModal.vue';
import { TAG_FILTER_MODEL, _OPEN_TAG_FILTER_MODAL_, _LOAD_REPORT_TAGS_, _OPEN_EXPORT_POSTS_MODAL_ } from '../components/TagModel';

export default {
  name: 'report-tag-list',
  components: {
    Datepicker,
    Pagination,
    TagListItems,
    TagFilterModal,
    ReportPostsModal,
  },
  data() {
    return {
      filter: { ...TAG_FILTER_MODEL },
      tags: null,
      posts: {
        list: null,
        total_items: null,
      },
      showTake: [
        { value: '10', text: '10' },
        { value: '20', text: '20' },
        { value: '50', text: '50' },
      ],
      filterTitle: 'Novo Filtro',
      pagination: {
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
        date_from: null,
        date_to: null,
        filter: null,
      },
    };
  },
  computed: {
    filters() {
      const { tagFilterList } = this.$store.state.feed;
      if (tagFilterList) {
        return tagFilterList;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTagFilterList',
    ]),
    editFilter() {
      this.filterTitle = 'Editar filtro';
      setTimeout(() => {
        Events.$emit(_OPEN_TAG_FILTER_MODAL_, this.filter);
        this.setToggle({ type: 'feed_tag_filter_modal', bool: true });
      }, 20);
    },
    getFilters() {
      this.getTagFilterList();
    },
    setFilter() {
      this.pagination.filter = this.filter;
      this.getList();
    },
    getList() {
      ReportService.getTagList(this.pagination)
        .then(response => {
          this.tags = response.tags;
          this.posts = response;
          Events.$emit(_LOAD_REPORT_TAGS_, response);
        });
    },
    exportPdf() {
      this.pagination.filter = this.filter;
      ReportService.exportPdf(this.pagination)
        .then(response => downloadWordFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    openExportCsv() {
      this.pagination.filter = this.filter;
      Events.$emit(_OPEN_EXPORT_POSTS_MODAL_, this.pagination);
      this.setToggle({ type: 'report_posts_modal', bool: true });
    },
    openFilter() {
      this.filterTitle = 'Novo filtro';
      Events.$emit(_OPEN_TAG_FILTER_MODAL_, { ...TAG_FILTER_MODEL });
      this.setToggle({ type: 'feed_tag_filter_modal', bool: true });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.pagination = pagination;
      this.getList();
    });
    this.getFilters();
  },

};
</script>

<style lang="scss" scoped>
</style>
